import { t } from "../../../services/utils";
import React from "react";
import {
  red700,
  green700,
  teal700,
  amberA700,
  orangeA700,
  grey600,
  primaryDark5,
} from "../../../constants/colors";
import achievementTypes from "../../../constants/achievement-types";
import Icon from "@material-ui/core/Icon";
import "../../../img/personalRecord.png";
import { monthToShortString, monthToString } from "../../../constants/month";
class AchievementView extends React.Component {
  constructor(props) {
    super(props);
  }
  getBadge = (image, backgroundColor, title, fontIcon) => {
    let styles = {
      badge: {
        display: "flex",
        width: 60,
        height: 60,
        // backgroundColor: red700,
        marginLeft: 10,
        borderRadius: 4,
      },
      badgeLeft: {
        fontSize: 18,
        marginTop: 5,
        marginLeft: 5,
        color: "white",
      },
      badgeRight: {
        marginLeft: "auto",
        marginRight: "auto",
        fontSize: 12,
        color: "white",
        marginTop: 6,
        fontWeight: "bold",
      },
      image: {
        height: 60,
        width: 60,
      },
    };
    let fa = fontIcon ? fontIcon : "fa-trophy";
    return (
      <div
        style={{
          ...styles.badge,
        }}
      >
        <img src={image} style={styles.image} />
        {/* <Icon style={styles.badgeLeft} className={`fa ${fa}`} /> */}
        {/* <div style={styles.badgeRight}>{title}</div> */}
      </div>
    );
  };
  getMain = (title, detail) => {
    let styles = {
      main: {
        display: "flex",
        marginLeft: 10,
        flex: "1 1 auto",
        flexDirection: "column",
      },
      title: {
        fontSize: 16,
        color: "#2A234E",
      },
      detail: {
        fontSize: 13,
        color: "#524D70",
      },
    };
    let main;
    if (detail) {
      main = (
        <div style={styles.main}>
          <div style={styles.title}>{title}</div>
          <div style={styles.detail}>{detail}</div>
        </div>
      );
    } else {
      main = (
        <div style={styles.main}>
          <div style={styles.title}>{title}</div>
        </div>
      );
    }
    return main;
  };
  render = () => {
    let background = require( "../../../img/pattern1.png");
    let styles = {
      container: {
        backgroundColor: primaryDark5,
        height: 75,
        width: "48.5%",
        display: "flex",
        alignItems: "center",
        borderRadius: 3,
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right",
      },
    };
    let badge = "";
    let main = "";
    let achievement = this.props.achievement;
    switch (achievement.type) {
      case achievementTypes.PR: {
        badge = this.getBadge(
          require( "../../../img/personalRecord.png"),
          orangeA700,
          "PR"
        );
        let detail = this.props.achievement.rm
          ? `1RM: ${achievement.rm}`
          : `Volume: ${achievement.vol}`;
        main = this.getMain(achievement.en, detail);
        break;
      }
      case achievementTypes.LOGGED_1ST_WORKOUT: {
        badge = this.getBadge(require( "../../../img/log1stWorkout.png"), green700, "1st");
        main = this.getMain(t("logged_1stWorkout"));
        break;
      }
      case achievementTypes.LOGGED_25X_WORKOUTS: {
        let numWorkouts = achievement.ref_id1 * 25;
        let image = "";
        if (numWorkouts === 25) {
          image = require( "../../../img/log25Workouts.png");
        }
        if (numWorkouts === 75) {
          image = require( "../../../img/log75Workouts.png");
        }
        if (numWorkouts === 100) {
          image = require( "../../../img/log100Workouts.png");
        }
        if (numWorkouts > 100) {
          image = require( "../../../img/perfectYear.png");
        }
        badge = this.getBadge(image, green700, numWorkouts);
        main = this.getMain(t("loggedNumworkoutsWorkouts", { numWorkouts }));
        break;
      }
      case achievementTypes.GOAL_UNLOCKED: {
        badge = this.getBadge(
          require( "../../../img/log1stWorkout.png"),
          red700,
          "\u2713\u2713",
          "fa-bullseye"
        );
        main = this.getMain(
          t("goalUnlocked"),
          "Target: " + Math.round(achievement.ta * 10) / 10
        );
        break;
      }
      case achievementTypes.PERFECT_WEEK: {
        badge = this.getBadge(require( "../../../img/perfectWeek.png"), teal700, "W");
        main = this.getMain(t("perfectWeek"), t("completed_3WorkoutsThisWeek"));
        break;
      }
      case achievementTypes.PERFECT_MONTH: {
        let monthShort = monthToShortString(achievement.ref_id1);
        let month = monthToString(achievement.ref_id1);
        badge = this.getBadge(
          require( "../../../img/perfectMonth.png"),
          amberA700,
          monthShort
        );
        main = this.getMain(
          t("perfect") + " " + month,
          t("completed_3WorkoutsEveryWeek")
        );
        break;
      }
      case achievementTypes.PERFECT_QUARTER: {
        badge = this.getBadge(require( "../../../img/perfectQuarter.png"), red700, "1/4");
        main = this.getMain(
          t("perfectQuater"),
          t("completed_3WorkoutsEveryWeek")
        );
        break;
      }
      case achievementTypes.PERFECT_HALF_YEAR: {
        badge = this.getBadge(require( "../../../img/perfectHalfYear.png"), red700, "1/2");
        main = this.getMain(
          t("perfectHalfYear"),
          t("completed_3WorkoutsEveryWeek")
        );
        break;
      }
      case achievementTypes.PERFECT_YEAR: {
        badge = this.getBadge(require( "../../../img/perfectYear.png"), red700, "Yr");
        main = this.getMain(
          t("unlockedPerfectYear"),
          t("completed_3WorkoutsEveryWeek")
        );
        break;
      }
    }
    return (
      <div style={styles.container}>
        {badge}
        {main}
      </div>
    );
  };
  static getHeight(props) {
    return 54;
  }
}
export default AchievementView;
